import React, { useLayoutEffect } from 'react';

import { useLayoutContext } from '@ott/layout-context';

import CollectionBlock from '../CollectionBlock';
import FirstCircle from './blocks/FirstCircle';
import SecondCircle from './blocks/SecondCircle';
import ThirdCircle from './blocks/ThirdCircle';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import styles from './CircleBlock.scss';

gsap.registerPlugin(ScrollTrigger);

const CircleBlock = () => {
  const { isDesktop } = useLayoutContext();

  useLayoutEffect(() => {
    const timeline = gsap.timeline({});

    const toggleVideo = (play: boolean) => {
      const video = document.getElementById('third-circle-video') as HTMLVideoElement;

      return () => {
        if (play) {
          video.play();
        } else {
          video.pause();
        }
      };
    };

    gsap.set('#circle-2', { display: 'none', opacity: 0, scale: 0.8 });
    gsap.set('#circle-3', { display: 'none', opacity: 0, scale: 0.8 });
    gsap.set('#collection-block', { display: 'none', opacity: 0, scale: 2, y: -50 });

    ScrollTrigger.create({
      trigger: '#circles-wrapper',
      start: 'center center',
      end: `+=${isDesktop ? 6000 : 4000}`,
      pin: true,
      scrub: true,
      snap: {
        snapTo: 1 / 4,
        duration: 0.6,
        delay: 0.01,
        ease: 'expo.out',
      },
      animation: timeline,
    });

    timeline
      .to('#circle-1-title', { opacity: 0, y: -50 }, '+=1')
      .to('#circle-2', { display: 'flex', opacity: 1, scale: 1 })
      .to('#circle-1', { opacity: 0 }, '<')

      .to('#circle-2-title', { opacity: 0, y: -50 })
      .to('#circle-3', { display: 'block', opacity: 1, scale: 1 })
      .to('#circle-2', { opacity: 0 }, '<')
      .call(toggleVideo(true))

      .to('#circle-3', { scale: 0.28, opacity: isDesktop ? 0.5 : 0 }, '>')
      .call(toggleVideo(false))
      .to('#collection-block', { display: 'block', opacity: 1, scale: 1 }, '<');
  }, [isDesktop]);

  return (
    <div className={styles.circlesWrapper} id="circles-wrapper">
      <FirstCircle />
      <SecondCircle />
      <ThirdCircle />
      <CollectionBlock />
    </div>
  );
};

export default CircleBlock;
